<template>
  <Header12 />
  <div class="body">
    <section class="background-bleu">
      <MenuTitle title="Nous contacter" subTitle="" srcImg="/images/pages/Rectangle13.jpg"
        backgroundSpan="span-background-blue" />
    </section>
    <section>
      <Formulaire />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import Formulaire from './formulaire.vue';
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../../MenuTitle";
useHead({
    title: 'EMCI : Contactez-nous',
    meta: [
        {
            name: 'description',
            content: ''
        }
    ]
})
</script>

<style scoped>
.body {
  overflow: hidden !important;
  margin-top: 120px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }
}
</style>